export default {
  navTab: ['今日日程', '我的日程', '已結束日程'],
  card: {
    group: '我的小組:',
    location: '地點:',
    viewCommitmentLetter: '查看承諾書',
    signCommitmentLetter: '已簽承諾書',
    checkinPhoto: '拍照簽到',
    interviewerCheckin: '已簽到',
    viewArrangement: '查看安排',
  },
  noData: '暫無日程',
  signOut: {
    confirmMsg: '確定退出面試評分系統？',
    cancelMsg: '取消退出',
  },
  getSchedules401: '登入過期,請重新登入',
};
